import { useQuery } from "@tanstack/react-query";
import { fetchICafeList, fetchCodes, fetchSecedeICafeList } from "@features/account/api";

export const useICafeList = (isLogin: boolean, isPlayncUser2: boolean) => {
  return useQuery({
    queryKey: ["iCafeList"],
    queryFn: async ({ signal }) => {
      const [iCafeListData, iCafeSecedeListData, codesData] = await Promise.all([fetchICafeList(signal), fetchSecedeICafeList(signal), fetchCodes()]);
      return { iCafeListData, iCafeSecedeListData, codesData };
    },
    select: (data) => {
      const franchiseCodes = data.codesData?.filter((item) => item.type === 11);

      // 프랜차이즈 정보 매핑
      const mapWithFranchiseInfo = (list: typeof data.iCafeListData = []) =>
        list?.map((item) => {
          const matchedFranchise = franchiseCodes?.find((fc) => fc.code === item.franchiseCode);
          const franchiseName = item.franchiseCode && item.franchiseCode !== 0 ? (matchedFranchise?.name ?? "") : "";
          const companyFullName = franchiseName ? `${franchiseName} ${item.companyName}` : item.companyName;

          return {
            ...item,
            franchiseName,
            companyFullName,
          };
        });

      // PC방 삭제 신청 목록
      const secedeList = new Set(data.iCafeSecedeListData?.map((item) => item.iCafeId?.toLowerCase()));

      // PC방 등록 후 승인 대기 목록
      const iCafePendingList = data.iCafeListData && mapWithFranchiseInfo(data.iCafeListData.filter((item) => item.companyStateCode === 0));

      // PC방 목록
      const iCafeList = data.iCafeListData && mapWithFranchiseInfo(data.iCafeListData.filter((item) => item.companyStateCode === 1 && item.iCafeId && !secedeList.has(item.iCafeId)));

      // 삭제 대기중 PC방 목록
      const iCafeClosingList = data.iCafeListData && mapWithFranchiseInfo(data.iCafeListData.filter((item) => item.companyStateCode === 1 && item.iCafeId && secedeList.has(item.iCafeId)));

      // 삭제된 PC방 목록
      const iCafeClosedList = data.iCafeListData && mapWithFranchiseInfo(data.iCafeListData.filter((item) => item.companyStateCode === 3));

      // 개인정보 및 사업장 전체 삭제 상태
      const isWithdrawn = iCafeList && iCafeList.length === 0 && secedeList.size > 0;

      // PC방 목록이 마지막 1개
      const isLastICafe = iCafeList && iCafeList.length === 1;

      // 승인 대기 목록이 있는 경우
      const hasPending = iCafePendingList && iCafePendingList.length > 0;

      // 대표 PC방 이름
      const primaryName = data.iCafeListData?.find((item) => item.isPrimary)?.companyName;

      // 대표 PC방 ID
      const primaryICafeId = iCafeList?.find((item) => item.isPrimary)?.iCafeId;

      return {
        noPrimaryICafe: !primaryICafeId,
        primaryICafeId,
        iCafePendingList,
        iCafeClosedList,
        iCafeClosingList,
        iCafeList,
        primaryName,
        isWithdrawn,
        hasPending,
        isLastICafe,
      };
    },
    meta: { requiresAuth: true }, // 로그인했을 때만 호출해야 하는 api임을 나타내는 메타정보 정의함
    enabled: isLogin && isPlayncUser2, // 로그인 && PC방 등록 승인 완료
    staleTime: 1000 * 60,
  });
};
